import { PaginatedResponse, User, DepartmentRead, UserAccessRead, UserAccessUpdate } from './types';

const API_BASE = `${process.env.REACT_APP_API_BASE_URL}/api/v1`;

// Универсальная функция запроса (аналогичная той, что у вас в документах)
async function request<T>(url: string, options: RequestInit = {}): Promise<T> {
  const token = localStorage.getItem('token');

  const headers: HeadersInit = {
    ...(token ? { 'Authorization': token } : {}),
    'Accept': 'application/json',
  };

  if (options.body && typeof options.body === 'string') {
    (headers as Record<string, string>)['Content-Type'] = 'application/json';
  }

  const finalHeaders = { ...headers, ...options.headers };

  const res = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers: finalHeaders,
  });

  if (res.status === 401) {
    throw new Error('Сессия истекла. Пожалуйста, войдите снова.');
  }

  if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);

  if (res.status === 204) return null as T;

  return res.json();
}

/**
 * Получить список пользователей
 */
export async function fetchUsers(page: number = 1, size: number = 20): Promise<PaginatedResponse<User>> {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size)
  });

  return request<PaginatedResponse<User>>(`/users/?${params.toString()}`);
}

/**
 * Получить список отделов для селекта/чекбоксов
 */
export async function fetchDepartments(): Promise<DepartmentRead[]> {
  // Запрашиваем size=200, чтобы получить все отделы разом для списка выбора
  const params = new URLSearchParams({
    page: '1',
    size: '200'
  });

  const response = await request<PaginatedResponse<DepartmentRead>>(`/departments/?${params.toString()}`);
  return response.items;
}

/**
 * Получить настройки доступа конкретного пользователя
 */
export async function fetchUserAccess(userId: number): Promise<UserAccessRead> {
  return request<UserAccessRead>(`/users/${userId}/access/`);
}

/**
 * Обновить настройки доступа пользователя
 */
export async function updateUserAccess(userId: number, payload: UserAccessUpdate): Promise<void> {
  return request<void>(`/users/${userId}/access/`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });
}